export interface ServiceAreasProps {
  title: string;
  subtitle: string;
  description: string;
  areas: string[];
  mapEmbed?: string;
}

export default function ServiceAreas({ title, subtitle, description, areas }: ServiceAreasProps) {
  return (
    <section className="bg-sage/10 py-24 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Content */}
          <div>
            <p className="text-bronze text-xs font-medium uppercase tracking-widest mb-3">Service Coverage</p>
            <h2 className="font-serif text-4xl md:text-5xl font-semibold text-charcoal leading-tight mb-4">
              {title}
            </h2>
            <p className="text-gray-600 leading-relaxed mb-8">{description}</p>

            {/* Area tags */}
            <div className="flex flex-wrap gap-2.5 mb-10">
              {areas.map((area) => (
                <span
                  key={area}
                  className="bg-white text-charcoal text-sm font-medium px-4 py-2 rounded-full border border-warmgray hover:border-bronze hover:text-bronze transition-colors cursor-default"
                >
                  {area}
                </span>
              ))}
            </div>

            <p className="text-gray-500 text-sm italic">{subtitle}</p>

            {/* CTA */}
            <div className="mt-8 flex items-center gap-3">
              <a
                href="tel:+17185550100"
                className="inline-flex items-center gap-2 bg-charcoal text-white font-medium px-6 py-3.5 rounded-md hover:bg-bronze transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-phone-line"></i>
                </div>
                Call for Pickup
              </a>
              <span className="text-sm text-gray-400">Free estimates, no commitment</span>
            </div>
          </div>

          {/* Map */}
          <div className="relative">
            <div className="w-full h-[480px] lg:h-[560px] rounded-2xl overflow-hidden border border-warmgray">
              <iframe
                title="Boro Rug & Flooring - Brooklyn Showroom Location"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d96708.34105053898!2d-74.03963533657767!3d40.650002080099226!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c25bae694479a3%3A0xb9949385da52e69e!2sBrooklyn%2C%20NY!5e0!3m2!1sen!2sus!4v1700000000000!5m2!1sen!2sus"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
            <div className="absolute bottom-4 left-4 bg-white rounded-xl px-4 py-3 flex items-center gap-3 border border-warmgray">
              <div className="w-8 h-8 flex items-center justify-center bg-bronze/10 rounded-full">
                <i className="ri-store-3-line text-bronze text-lg"></i>
              </div>
              <div>
                <p className="text-sm font-bold text-charcoal">Boro Rug &amp; Flooring</p>
                <p className="text-xs text-gray-500">1247 Flatbush Ave, Brooklyn, NY 11226</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
